import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { isOnlineAtom } from "../../../../new_appointment/appoinment/atom/AppointmentAtoms";
import { useAtom } from "jotai";

const SidebartemSmall = ({
  name,
  activeIcon,
  inactiveIcon,
  className,
  onClick,
  route,
  type = "sidebar",
  activeClass,
  // expanded,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const [isOnline] = useAtom(isOnlineAtom);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // //("route------", route);

  return type === "sidebar" ? (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${className} ${
        location.pathname === route ? "sidebar-link-active" : ""
      }`}
      onClick={onClick}
    >
      <div className="relative border border-red-500">
        <img
          src={`${
            isHovered || location.pathname === route
              ? `${activeIcon}`
              : `${inactiveIcon}`
          }`}
          width={"20px"}
          height={"20px"}
        />
        {/* <span>
          {isHovered || location.pathname === route ? activeIcon : inactiveIcon}
        </span> */}
      </div>

      {/* {expanded && <span style={{ marginInlineStart: "12px" }}>{name}</span>} */}
    </div>
  ) : (
    <div
      onClick={onClick}
      className={`${className}  ${
        location.pathname + location.search === route && activeClass
          ? activeClass
          : ""
      }`}
    >
      <div className="relative">
        {location.pathname + location.search === route
          ? activeIcon
          : inactiveIcon}
        {name === "Appointment" && (
          <div
            className={` ${
              isOnline ? "bg-green-500" : "bg-yellow-500"
            } w-3 h-3 rounded-full absolute -top-1 -right-2`}
          ></div>
        )}
      </div>
      {/* <img
        src={`${
          location.pathname === route ? `${activeIcon}` : `${inactiveIcon}`
        }`}
      /> */}
    </div>
  );
};

export default SidebartemSmall;
